/*!
 * Roundway micro-quiz popup — bandit arm 'microquiz'.
 *
 *  Step 1  one question: what are you trying to sort first? (six taps)
 *  Step 2  email capture, headline reframed around the tap
 *  Step 3  discount reveal + "start here" link for that interest
 *
 * Config:
 *   <script src="...roundway-popup-microquiz.js"
 *           data-api-base="https://xxx.supabase.co/functions/v1"
 *           data-anon-key="..."
 *           data-delay="6000"
 *           data-discount-code="CODE"></script>
 *
 * Tracking:
 *   popup-event   view / submit / dismiss   (variant MICROQUIZ)
 *   behavr-event  quiz_choice with tag interest:<slug>, submit on capture
 *   quiz-submit   product 'popup-microquiz', answers { interest }, interest tag
 */
(function () {
  'use strict';
  // ── RETIRED FOR GOOD (2026-09-18) ──
  // The question-card design converted at 1-3% against the original
  // split-image popup's 6-12%. It must never render again, not even behind a
  // force flag or a stale cached roundway-bandit.js on the live theme.
  window.__RW_POPUP_MICROQUIZ__ = true;
  return;
  /* eslint-disable no-unreachable */
  if (window.__RW_POPUP_MICROQUIZ__) return;
  try {
    if (window.__RW_BLOCK_POPUPS__ || /^\/pages\/(glp1|glp1-terms|quiz|health-quiz)(\/|$)/i.test(location.pathname)) return;
  } catch (_) {}
  window.__RW_POPUP_MICROQUIZ__ = true;

  var POPUP_ID = 'microquiz';
  var SEEN_KEY = 'rw_microquiz_state';
  var COPY_KEY = 'rw_microquiz_copy';
  var COOLDOWN_DAYS = 14;
  var SITE = 'https://roundwaysupplements.com';
  var UTM = 'utm_source=popup&utm_medium=onsite&utm_campaign=popup-microquiz&utm_content=';

  /* ---------------- config ---------------- */
  var cfg = window.RoundwayMicroQuizConfig || {};
  (function () {
    var s = document.currentScript;
    if (!s) {
      var all = document.getElementsByTagName('script');
      for (var i = all.length - 1; i >= 0; i--) {
        if (all[i].src && /roundway-popup-microquiz\.js/.test(all[i].src)) { s = all[i]; break; }
      }
    }
    if (s) {
      cfg.apiBase = cfg.apiBase || s.getAttribute('data-api-base') || '';
      cfg.anonKey = cfg.anonKey || s.getAttribute('data-anon-key') || '';
      cfg.delay = cfg.delay || parseInt(s.getAttribute('data-delay') || '6000', 10);
      cfg.discountCode = cfg.discountCode || s.getAttribute('data-discount-code') || '';
    }
  })();
  cfg.delay = isNaN(cfg.delay) ? 6000 : cfg.delay;
  cfg.discountCode = cfg.discountCode || '';
  /* The code is never shipped in the page; it is returned after a valid sign-up. */
  function rwReveal(root, email) {
    if (!cfg.apiBase) return Promise.resolve();
    return fetch(cfg.apiBase + '/popup-reveal-code', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', apikey: cfg.anonKey || '', Authorization: 'Bearer ' + (cfg.anonKey || '') },
      body: JSON.stringify({ email: email, brand: 'roundway', source: 'popup-microquiz' })
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (!j || !j.code) return;
      cfg.discountCode = j.code;
      // Mystery tier (10/15/20) from popup-reveal-code; shared with the announcement bar so there is only ever one code.
      if (j.pct) root.querySelectorAll('[data-rw-pct]').forEach(function (el) { el.textContent = j.pct + '%'; });
      try { localStorage.setItem('rw_mystery', JSON.stringify({ code: j.code, pct: j.pct || null, expires_at: j.expires_at || null })); } catch (_) {}
      root.querySelectorAll('[data-code]').forEach(function (b) {
        b.setAttribute('data-code', j.code);
        var st = b.parentNode && b.parentNode.querySelector('strong');
        if (st) st.textContent = j.code;
      });
      root.querySelectorAll('a[href*="/discount/"]').forEach(function (a) {
        a.setAttribute('href', a.getAttribute('href').replace(/\/discount\/[^?]*/, '/discount/' + encodeURIComponent(j.code)));
      });
    }).catch(function () {});
  }


  /* ---------------- the one question ---------------- */
  /* line = control copy, stat = stadium-pitch UK fact, loss = loss framing */
  var OPTIONS = [
    {
      slug: 'sleep-stress', label: 'Sleep and stress',
      head: 'Sleep first. Here is where to start.',
      line: 'Most people fix the evening, not the morning.',
      stat: 'The average UK night is 7 hours 16 minutes. Nowhere near enough for how most people feel.',
      loss: 'Another month of 3am wake-ups costs you more than the pack does.',
      cta: 'See the calm and rest range',
      url: SITE + '/pages/tired-and-wired'
    },
    {
      slug: 'energy-focus', label: 'Energy and focus',
      head: 'Energy first. Here is where to start.',
      line: 'The 3pm dip usually starts long before 3pm.',
      stat: '13% of Britons feel tired all of the time. Another 25% feel it most of the time.',
      loss: 'You have already written off this week. Do not write off next one too.',
      cta: 'See the everyday range',
      url: SITE + '/pages/tired-and-wired'
    },
    {
      slug: 'gut-digestion', label: 'Gut and digestion',
      head: 'Gut first. Here is where to start.',
      line: 'Bloating, irregularity, the after-antibiotics months.',
      stat: 'Only 4 in 100 UK adults hit the 30g fibre target. The other 96 starve their gut bacteria daily.',
      loss: 'Every day you wait is another day those bacteria go unfed.',
      cta: 'See the gut and flora range',
      url: SITE + '/collections/gut-and-flora'
    },
    {
      slug: 'liver-support', label: 'Liver and the morning after',
      head: 'Liver support. Here is where to start.',
      line: 'Four ingredients, not one. Read the label.',
      stat: 'At least two million people in the UK live with a liver condition. Most have no symptoms yet.',
      loss: 'It does not complain until late. That is the problem.',
      cta: 'See the liver support pack',
      url: SITE + '/pages/keep-the-cleanse-going'
    },
    {
      slug: 'immune-support', label: 'Immune support',
      head: 'Immune support. Here is where to start.',
      line: 'Most of your immune cells live in the gut lining.',
      stat: 'England used 17.5 daily doses of antibiotics per 1,000 people per day last year. Nothing gets put back.',
      loss: 'Every reset you ignore is one you pay for next winter.',
      cta: 'See the immune range',
      url: SITE + '/collections/immune-and-defence'
    },
    {
      slug: 'weight-appetite', label: 'Weight and appetite',
      head: 'Appetite first. Here is where to start.',
      line: 'Fibre and flora do more of this than willpower.',
      stat: 'More than half the calories in the average UK diet come from ultra-processed food.',
      loss: 'Willpower has had its go. It is not the thing that is missing.',
      cta: 'See the gut and flora range',
      url: SITE + '/pages/afternoon-cravings'
    }
  ];

  /* ---------------- copy variants (A/B/C) ---------------- */
  var COPY_VARIANTS = [
    {
      id: 'v1',
      variant: 'MICROQUIZ',
      lineKey: 'line',
      eyebrow: 'One question',
      head: 'What are you trying to sort first?',
      sub: 'Tap one. We will point you at the right place, and there is a mystery discount on the other side: 10, 15 or 20% off.',
      formEyebrow: 'Almost there',
      submit: 'Reveal my mystery code',
      note: 'Magnesium pack on us over £25.'
    },
    {
      id: 'v2',
      variant: 'MICROQUIZ_STAT',
      lineKey: 'stat',
      eyebrow: '4 in 100',
      head: 'Most of the country is short on something.',
      sub: 'Only 4 in 100 UK adults eat enough fibre. Nearly 1 in 5 is low on vitamin D. Tap the one you feel most.',
      formEyebrow: 'Your number',
      submit: 'Show me where to start',
      note: 'UK figures, UK made. Magnesium pack on us over £25.'
    },
    {
      id: 'v3',
      variant: 'MICROQUIZ_LOSS',
      lineKey: 'loss',
      eyebrow: 'Before you go',
      head: 'Picking the wrong one first is why people quit.',
      sub: '42% of British adults bought no supplements at all in six months. Most started with the wrong thing. Tap what you actually feel.',
      formEyebrow: 'Last step',
      submit: 'Reveal my code before I close this',
      note: 'This code is for this visit. Magnesium pack on us over £25.'
    }
  ];
  function pickCopy() {
    var forced = null;
    try { forced = new URLSearchParams(location.search).get('rw_force_copy'); } catch (_) {}
    var id = forced;
    if (!id) {
      try { id = localStorage.getItem(COPY_KEY); } catch (_) {}
    }
    var found = null;
    for (var i = 0; i < COPY_VARIANTS.length; i++) if (COPY_VARIANTS[i].id === id) found = COPY_VARIANTS[i];
    if (!found) {
      found = COPY_VARIANTS[Math.floor(Math.random() * COPY_VARIANTS.length)];
      try { localStorage.setItem(COPY_KEY, found.id); } catch (_) {}
    }
    return found;
  }
  var COPY = pickCopy();
  var VARIANT = COPY.variant;


  /* ---------------- state ---------------- */
  function readState() {
    try { return JSON.parse(localStorage.getItem(SEEN_KEY) || '{}') || {}; } catch (_) { return {}; }
  }
  function writeState(patch) {
    var s = readState();
    for (var k in patch) s[k] = patch[k];
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(s)); } catch (_) {}
  }
  function sessionId() {
    try {
      if (window.RoundwayBandit && window.RoundwayBandit.sessionId) return window.RoundwayBandit.sessionId;
      var v = sessionStorage.getItem('rw_session_id');
      if (!v) {
        v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : 'rwm-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem('rw_session_id', v);
      }
      return v;
    } catch (_) { return 'rwm-' + Date.now(); }
  }
  function shouldShow() {
    var st = readState();
    if (st.submitted) return false;
    if (st.dismissedAt && Date.now() - st.dismissedAt < COOLDOWN_DAYS * 864e5) return false;
    if (/\/(cart|checkout|account)/.test(location.pathname)) return false;
    return true;
  }

  /* ---------------- tracking ---------------- */
  function post(path, payload) {
    if (!cfg.apiBase) return Promise.resolve(null);
    return fetch(cfg.apiBase + '/' + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: cfg.anonKey || '',
        Authorization: 'Bearer ' + (cfg.anonKey || '')
      },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return null; }); })
      .catch(function () { return null; });
  }
  function track(event, extra) {
    var payload = {
      event: event,
      variant: VARIANT,
      popup_id: POPUP_ID,
      popup_name: 'Micro-quiz (one question) ' + COPY.id,
      page: location.pathname,
      session_id: sessionId()
    };
    for (var k in (extra || {})) payload[k] = extra[k];
    return post('popup-event', payload);
  }
  function impressionId() {
    return (window.RoundwayBandit && window.RoundwayBandit.impressionId) || null;
  }

  /* ---------------- teaser reuse ---------------- */
  var teaserEl = null;
  var currentRoot = null;
  function teaserAllowed() {
    if (readState().submitted) return false;
    if (/\/(cart|checkout|account)/.test(location.pathname)) return false;
    return true;
  }
  function showTeaser() {
    if (!teaserAllowed()) return;
    if (teaserEl) { teaserEl.style.display = ''; teaserEl.classList.add('is-visible'); return; }
    var original = document.getElementById('rw-popup-teaser');
    if (!original) return;
    teaserEl = original.cloneNode(true);
    teaserEl.id = 'rw-popup-teaser';
    original.parentNode.replaceChild(teaserEl, original);
    teaserEl.style.display = '';
    teaserEl.classList.add('is-visible');
    teaserEl.addEventListener('click', function () {
      if (currentRoot && document.body.contains(currentRoot)) return;
      if (!teaserAllowed()) return;
      open();
    });
  }
  function hideTeaser() { if (teaserEl) teaserEl.classList.remove('is-visible'); }
  function removeTeaser() { if (teaserEl) { try { teaserEl.remove(); } catch (_) {} teaserEl = null; } }

  /* ---------------- markup ---------------- */
  function build() {
    var opts = OPTIONS.map(function (o) {
      return '<button class="rwm-opt" type="button" data-slug="' + o.slug + '">' + o.label + '</button>';
    }).join('');

    var root = document.createElement('div');
    root.className = 'rwm-root';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.innerHTML =
      '<div class="rwm-scrim" data-close="1"></div>' +
      '<div class="rwm-wrap"><div class="rwm-modal">' +
        '<div class="rwm-brand"><img src="https://cdn.shopify.com/s/files/1/0893/9185/7991/files/Roundway_White.png" alt="Roundway Supplements" width="168" height="auto"></div>' +
        '<div class="rwm-q">' +
          '<p class="rwm-eyebrow">' + COPY.eyebrow + '</p>' +
          '<h2>' + COPY.head + '</h2>' +
          '<p class="rwm-sub">' + COPY.sub + '</p>' +
          '<div class="rwm-options">' + opts + '</div>' +
          '<a class="rwm-link" href="#" data-close="1">No thanks, I’m happy paying full price</a>' +
        '</div>' +
        '<form class="rwm-form" novalidate>' +
          '<p class="rwm-eyebrow">' + COPY.formEyebrow + '</p>' +
          '<h2 class="rwm-head"></h2>' +
          '<p class="rwm-sub rwm-line"></p>' +
          '<label for="rwm-email">Send my code to</label>' +
          '<input id="rwm-email" type="email" inputmode="email" autocomplete="email" placeholder="you@email.com" required>' +
          '<button class="rwm-btn" type="submit">' + COPY.submit + '<span aria-hidden="true">&rarr;</span></button>' +
          '<p class="rwm-err" aria-live="polite"></p>' +
          '<p class="rwm-offerline">' + COPY.note + '</p>' +
          '<button class="rwm-back" type="button">Pick something else</button>' +
          '<p class="rwm-fine">Made in the UK · One email, then our usual notes. Unsubscribe any time.</p>' +
        '</form>' +
        '<div class="rwm-done">' +
          '<p class="rwm-eyebrow">You are in</p>' +
          '<h2>Here is your code.</h2>' +
          '<div class="rwm-code"><strong>' + cfg.discountCode + '</strong>' +
            '<button type="button" class="rwm-copy" data-code="' + cfg.discountCode + '">Copy</button></div>' +
          '<p class="rwm-sub"><span data-rw-pct>10%</span> off your first order. Tap below and we will apply it for you.</p>' +
          '<a class="rwm-btn rwm-go" href="' + SITE + '/collections/all">Start here<span aria-hidden="true">&rarr;</span></a>' +
          '<p class="rwm-trust">Made in the UK · Magnesium Pack On Us Over £25 · Shipping On Us Over £34</p>' +
        '</div>' +
      '</div></div>';
    return root;
  }

  /* ---------------- open ---------------- */
  function open() {
    hideTeaser();
    var root = build();
    currentRoot = root;
    var picked = null;
    document.body.appendChild(root);
    requestAnimationFrame(function () { root.classList.add('rwm-open'); });
    track('view');
    writeState({ lastShownAt: Date.now() });

    function close(dismissed) {
      if (dismissed) {
        writeState({ dismissedAt: Date.now() });
        track('dismiss');
        post('behavr-event', { event: 'dismiss', session_id: sessionId(), impression_id: impressionId() });
      }
      root.classList.remove('rwm-open');
      setTimeout(function () {
        try { root.remove(); } catch (_) {}
        currentRoot = null;
        if (teaserAllowed()) showTeaser();
      }, 180);
    }

    function choose(slug) {
      for (var i = 0; i < OPTIONS.length; i++) if (OPTIONS[i].slug === slug) picked = OPTIONS[i];
      if (!picked) return;
      writeState({ interest: picked.slug });
      root.querySelector('.rwm-head').textContent = picked.head;
      root.querySelector('.rwm-line').textContent = picked[COPY.lineKey] || picked.line;
      root.classList.add('rwm-step-email');
      post('behavr-event', {
        event: 'quiz_choice',
        session_id: sessionId(),
        impression_id: impressionId(),
        tag: 'interest:' + picked.slug
      });
      if (!window.matchMedia('(max-width:760px)').matches) {
        setTimeout(function () {
          try { root.querySelector('#rwm-email').focus({ preventScroll: true }); } catch (_) {}
        }, 200);
      }
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-close]') : null;
      if (t) { e.preventDefault(); close(true); return; }
      var opt = e.target.closest ? e.target.closest('.rwm-opt') : null;
      if (opt) { opt.classList.add('is-picked'); choose(opt.getAttribute('data-slug')); return; }
      var back = e.target.closest ? e.target.closest('.rwm-back') : null;
      if (back) {
        root.classList.remove('rwm-step-email');
        root.querySelectorAll('.rwm-opt').forEach(function (el) { el.classList.remove('is-picked'); });
        return;
      }
      var copy = e.target.closest ? e.target.closest('.rwm-copy') : null;
      if (copy) {
        try {
          navigator.clipboard.writeText(copy.getAttribute('data-code'));
          copy.textContent = 'Copied';
        } catch (_) {}
      }
    });
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape' && document.body.contains(root)) { close(true); document.removeEventListener('keydown', onKey); }
    });

    root.querySelector('.rwm-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = root.querySelector('#rwm-email');
      var err = root.querySelector('.rwm-err');
      var btn = root.querySelector('.rwm-form .rwm-btn');
      var email = (input.value || '').trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'That email doesn\u2019t look right.'; return; }
      err.textContent = '';
      btn.disabled = true; btn.textContent = 'Sending\u2026';

      var slug = picked ? picked.slug : 'unknown';
      var tags = ['popup-microquiz', 'popup-copy-' + COPY.id, 'interest:' + slug, 'lc:interest-' + slug];

      rwReveal(root, email).then(function () { return Promise.all([
        track('submit', { email: email, tags: tags }),
        post('behavr-event', { event: 'submit', session_id: sessionId(), impression_id: impressionId(), email: email }),
        post('quiz-submit', {
          product: 'popup-microquiz',
          variant: COPY.id,
          persona: slug,
          answers: { interest: slug },
          email: email,
          page_handle: location.pathname,
          session_id: sessionId(),
          discount_code: cfg.discountCode,
          top_tags: ['interest:' + slug]
        })
      ]); }).then(function () {
        writeState({ submitted: true, submittedAt: Date.now() });
        var go = root.querySelector('.rwm-go');
        var dest = picked ? picked.url : SITE + '/collections/all';
        var sep = dest.indexOf('?') >= 0 ? '&' : '?';
        go.setAttribute('href', SITE + '/discount/' + encodeURIComponent(cfg.discountCode) +
          '?redirect=' + encodeURIComponent(dest.replace(SITE, '') + sep + UTM + slug));
        if (picked) go.innerHTML = picked.cta + '<span aria-hidden="true">&rarr;</span>';
        root.classList.add('rwm-step-done');
        removeTeaser();
      }).catch(function () {
        btn.disabled = false;
        btn.innerHTML = COPY.submit + '<span aria-hidden="true">&rarr;</span>';
        err.textContent = 'Something went wrong. Try again?';
      });
    });
  }

  /* ---------------- boot ---------------- */
  function start(arm) {
    if (arm !== 'microquiz') return;
    if (teaserAllowed()) showTeaser();
    if (!shouldShow()) return;
    var fired = false;
    function go() { if (!fired) { fired = true; open(); } }
    setTimeout(go, cfg.delay);
    document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) go(); });
    var scrolled = false;
    window.addEventListener('scroll', function () {
      if (scrolled) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.45) { scrolled = true; go(); }
    }, { passive: true });
  }
  function boot() {
    if (!window.RoundwayBandit || !window.RoundwayBandit.ready) {
      var attempts = 0;
      var wait = setInterval(function () {
        attempts++;
        if (window.RoundwayBandit && window.RoundwayBandit.ready) { clearInterval(wait); boot(); }
        else if (attempts >= 20) clearInterval(wait);
      }, 50);
      return;
    }
    if (window.RoundwayBandit.splitArm) { start(window.RoundwayBandit.splitArm); return; }
    window.RoundwayBandit.ready.then(function (res) { start(res && res.format); });
  }

  window.RoundwayMicroQuiz = { open: open, options: OPTIONS };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
